import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_BUSQUEDACPA } from '../../../../../config/forms'
import { Card, Row, Col } from 'react-bootstrap'
import { Dialog, Tooltip, Button } from '@material-ui/core'
import DialogView from '../../../../Dialogos/DialogView'
import DescargaPdf from '../../../../PdfDownload/container/DescargaPdf'
import DatosBusquedaCpa from '../../../components/DatosBusquedaCpa'
import TicketDeDescarga from '../../../../PdfDownload/container/TicketDeDescarga'
import { COLORES } from '../../../../../config/colores'

function BusquedaCpa1 (props) {
  const { handleClose, estadoCpa, detalleCompletoCpa, noShowButton = false } = props
  const [open, setOpen] = useState(false)
  const [nombreFoto, setNombreFoto] = useState('')
  const [urlFoto, setUrlFoto] = useState(null)

  const urlPdf = `${process.env.REACT_APP_PDF_URL}${detalleCompletoCpa.ctg}.pdf`

  const openDialogFoto = (foto, alt) => {
    setOpen(true)
    setUrlFoto(foto)
    setNombreFoto(alt)
  }

  const closeDialogFoto = () => {
    setOpen(false)
    setUrlFoto(null)
    setNombreFoto('')
  }

  const estado = estadoCpa.estadoCarga ? estadoCpa.estadoCarga : null

  const estadoCarga = (estado && estado === 'en_playa' && detalleCompletoCpa.fechaDeEgresoPlaya)
    ? 'ENTRE PLAYA Y CALADO'
    : (estado && estado === 'calada' && estadoCpa.estadoCtg === 'R')
      ? 'Rechazada'
      : (estadoCpa.rechazoAdministrativoCalado === 'R'
        ? 'Rechazo administrativo'
        : (estado && estado === 'calada' && estadoCpa.fechaDeEgresoCalado && !estadoCpa.fechaDeBruto
          ? 'Lista para bruto'
          : (estadoCpa.volcadoraCamiones && !estadoCpa.fechaDeDestare)
            ? 'Con volcado'
            : estadoCpa.estadoCarga))

  return (
    <>
      <Dialog
        open={open}
        onClose={closeDialogFoto}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={closeDialogFoto}
          title=' '
          content={<img src={urlFoto} alt={nombreFoto} style={{ width: '100%', margin: 'auto' }} />}
        />
      </Dialog>

      { (estadoCpa.length === 0 && detalleCompletoCpa.length === 0)
        ? <div className='loader' />
        : <div style={{ marginTop: '-2%' }}>
          <h4 style={{ textAlign: 'center' }}>
                  Detalle de CTG número <b>{estadoCpa.ctg}</b>
          </h4>

          { estadoCpa.estadoCarga &&
          <h5 style={{ textAlign: 'center' }}>
            <b>Estado de carga: {estadoCarga.toUpperCase()}</b>
          </h5>
          }
          <br />

          { estadoCpa && detalleCompletoCpa &&
          <Card className='shadow bg-white rounded text-left'>
            <Card.Body style={{ fontSize: '1.2em' }}>
              <DatosBusquedaCpa
                estadoCpa={estadoCpa}
                detalleCompletoCpa={detalleCompletoCpa}
                fotoCalado={props.fotoCalado}
                fotoBruto={props.fotoBruto}
                openDialogFoto={openDialogFoto}
              />
            </Card.Body>

            <Row style={{ margin: '0 12px' }}>
              <Col md={3}>
                        Descargar PDF desde ARCA
                <Tooltip title={'Descargar PDF desde ARCA'}>
                  <DescargaPdf url={urlPdf} filename={detalleCompletoCpa.ctg} />
                </Tooltip>
              </Col>
              <Col md={7}>
                {estadoCpa.fechaDeDestare &&
                <>
                            Ticket de descarga
                  <Tooltip title={'Certificado de descarga'}>
                    <TicketDeDescarga numero={estadoCpa.ctg} />
                  </Tooltip>
                </>
                }
              </Col>

              {!noShowButton &&
              <Col md={2}>
                <Button
                  style={{ margin: 'auto', backgroundColor: COLORES.grey.dark, color: 'white' }}
                  onClick={handleClose}
                  size='small'
                >
                            Finalizar consulta
                </Button>
              </Col>
              }
            </Row>
          </Card>
          }
        </div>
      }
    </>

  )
}

const mapStateToProps = (state) => ({
  estadoCpa: state.camionesIngreso.estadoCpa,
  detalleCompletoCpa: state.camionesIngreso.detalleCompletoCpa,
  fotoCalado: state.calado.fotoCea,
  fotoBruto: state.pesado.fotoCeaBruto
})

const withRedux = connect(mapStateToProps, null)
const withReduxForm = reduxForm({ form: FORM_BUSQUEDACPA })

export default withRedux(withReduxForm(BusquedaCpa1))
